import { User, Provider } from 'interfaces';

export enum TaskStatus {
  toDo = 'toDo',
  inProgress = 'inProgress',
  readyForReview = 'readyForReview',
  revisionRequired = 'revisionRequired',
  autoComplete = 'autoComplete',
  complete = 'complete',
  closed = 'closed',
  error = 'error',
}

export interface Task {
  id: string;
  assignee: User;
  provider: Provider;
  dateSubmitted: string;
  imageLocation: string;
  parsedDataLocation: string;
  status: TaskStatus;
}
